import { render, staticRenderFns } from "./ordinaryModal.vue?vue&type=template&id=fa81d7fa&"
import script from "./ordinaryModal.vue?vue&type=script&lang=js&"
export * from "./ordinaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports